// extracted by css-extract-rspack-plugin
export default {"trialExpiryButton":"src-modules-desktop-components-TrialExpiryModal-components-TrialExpiryButton-TrialExpiryButton-module__trialExpiryButton-IZxW9y"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"trialExpiryButton\":\"src-modules-desktop-components-TrialExpiryModal-components-TrialExpiryButton-TrialExpiryButton-module__trialExpiryButton-IZxW9y\"}";
        // 1793873552396
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  